import { ServiceRecords } from '@/service/records/serviceRecords'
import { ServicePrescription } from '@/service/prescription/servicePrescription'
import Swal from 'sweetalert2'

const serviceRecords = new ServiceRecords()
const servicePRescription = new ServicePrescription()
export default {
  namespaced: true,
  state: {
    loadingModelo: false,
    ProntuarioList: [],
    pronturio: null,
    uuid: null,
    records: {
      anammese: {
        complaint: '',
        hpma: '',
        personal_historic: '',
        family_historic: '',
      },
      exPhysicist: {},
      resExams: {},
      diagnosis: {},
      conduct: '',
      prescription: {
        medicamentsSelected: '',
        selectVia: '',
        selectCondicao: '',
        medicaments: [],
        optionsVia: [
          { name: 'Oral' },
          { name: 'Intramuscular' },
          { name: 'Intravenosa' },
          { name: 'Subcutânea' },
          { name: 'Tópica' },
          { name: 'Inalatória' },
          { name: 'Oftálmica' },
          { name: 'Ótica' },
          { name: 'Nasal' },
          { name: 'Vaginal' },
          { name: 'Retal' },
          { name: 'Intratecal' },
          { name: 'Intracardíaca' },
          { name: 'Intraperitoneal' },
          { name: 'Intraóssea' },
          { name: 'Intracavernosa' },
          { name: 'Intracavitária' },
          { name: 'Intracraniana' },
          { name: 'Intradermica' },
          { name: 'Intradérmica' },
          { name: 'Intradural' },
          { name: 'Intra-articular' },
          { name: 'Intra-arterial' },
          { name: 'Intra-ocular' },
          { name: 'Intra-uterina' },
          { name: 'Intravaginal' },
          { name: 'Intravesical' },
          { name: 'Intraventricular' },
          { name: 'Intravítrea' },
          { name: 'Intracelular' },
          { name: 'Intracoronariana' },
          { name: 'Intracoronária' },
        ],
        optionscondicao: [
          { titulo: 'Em jejum' },
          { titulo: 'Antes das refeições' },
          { titulo: 'Depois das refeições' },
          { titulo: 'Ao deitar' },
          { titulo: 'Ao acordar' },
          { titulo: 'A cada 6 horas' },
          { titulo: 'A cada 8 horas' },
          { titulo: 'A cada 12 horas' },
          { titulo: 'A cada 24 horas' },
          { titulo: 'A cada 48 horas' },
          { titulo: 'A cada 72 horas' },
          { titulo: 'A cada 7 dias' },
          { titulo: 'A cada 15 dias' },
          { titulo: 'A cada 30 dias' },
          { titulo: 'A cada 60 dias' },
          { titulo: 'A cada 90 dias' },
          { titulo: 'A cada 180 dias' },
          { titulo: 'A cada 365 dias' },
          { titulo: 'A cada 730 dias' },
          { titulo: 'A cada 1095 dias' },
          { titulo: 'A cada 1460 dias' },
          { titulo: 'A cada 1825 dias' },
          { titulo: 'A cada 2190 dias' },
          { titulo: 'A cada 2555 dias' },
          { titulo: 'A cada 2920 dias' },
          { titulo: 'A cada 3285 dias' },
          { titulo: 'A cada 3650 dias' },
          { titulo: 'A cada 4015 dias' },
          { titulo: 'A cada 4380 dias' },
          { titulo: 'A cada 4745 dias' },
          { titulo: 'A cada 5110 dias' },
          { titulo: 'A cada 5475 dias' },
          { titulo: 'A cada 5840 dias' },
          { titulo: 'A cada 6205 dias' },
          { titulo: 'A cada 6570 dias' },
          { titulo: 'A cada 6935 dias' },
          { titulo: 'A cada 7300 dias' },
          { titulo: 'A cada 7665 dias' },
          { titulo: 'A cada 8030 dias' },
          { titulo: 'A cada 8395 dias' },
        ],
        formPayload: {},
        prescriptionModelo: [],
        prescriptionModeloSelected: '',
        uso: '',
        qtd: '',
      },
    },
  },
  getters: {
    getProntuarioList: state => state.ProntuarioList,
    getProntuarioByuuid: state => state.ProntuarioList.find(prontuario => prontuario.uuid === state.uuid),
    getAnammese: state => state.records.anammese,
    getExPhysicist: state => state.records.exPhysicist,
    getResExams: state => state.records.resExams,
    getDiagnosis: state => state.records.diagnosis,
    getConduct: state => state.records.conduct,
    getPrescription: state => state.records.prescription,
    getMedicaments: state => state.records.prescription.medicaments,
    getFormPayload: state => state.records.prescription.formPayload,
    getPrescriptionModelo: state => state.records.prescription.prescriptionModelo,
    getPrescriptionModeloSelected: state => state.records.prescription.prescriptionModeloSelected,
    getLoadingModelo: state => state.loadingModelo,
  },
  mutations: {
    SetProntuarioList(state, ProntuarioList) {
      state.ProntuarioList = ProntuarioList
    },
    SetUuid(state, uuid) {
      state.uuid = uuid
    },
    SetRecords(state, records) {
      state.records.anammese = {
        complaint: records.complaint,
        hpma: records.hpma,
        personal_historic: records.personal_historic,
        family_historic: records.family_historic,
      }
      state.records.exPhysicist = records.exPhysicist
      state.records.resExams = records.resExams
      state.records.diagnosis = records.diagnosis
      state.records.conduct = records.conduct
    },
    SetAnammese(state, anammese) {
      state.records.anammese = anammese
    },
    SetExPhysicist(state, exPhysicist) {
      state.records.exPhysicist = exPhysicist
    },
    SetResExams(state, resExams) {
      state.records.resExams = resExams
    },
    SetDiagnosis(state, diagnosis) {
      state.records.diagnosis = diagnosis
    },
    SetConduct(state, conduct) {
      state.records.conduct = conduct
    },
    SetPrescription(state, prescription) {
      state.records.prescription = prescription
    },
    SetMedicaments: (state, medicaments) => {
      state.records.prescription.medicaments = medicaments
    },
    SetFormPayload: (state, formPayload) => {
      state.records.prescription.formPayload = formPayload
    },
    SetPrescriptionModelo: (state, prescriptionModelo) => {
      state.records.prescription.prescriptionModelo = prescriptionModelo
    },
    SetPrescriptionModeloSelected: (state, prescriptionModeloSelected) => {
      state.records.prescription.prescriptionModeloSelected = prescriptionModeloSelected
    },
    setLoadingModelo: (state, loadingModelo) => {
      state.loadingModelo = loadingModelo
    },
  },
  actions: {
    async fetchProntuarioList({ commit }) {
      try {
        const prontuarioList = await serviceRecords.recordsAll()
        commit('SetProntuarioList', prontuarioList)
      } catch (error) {
        console.error(error)
        Swal.fire({
          icon: 'error',
          title: 'Erro ao buscar prontuários',
          text: 'Ocorreu um erro ao buscar os prontuários. Tente novamente mais tarde.',
        })
      }
    },
    async fetchProntuarioById({ commit, state }, id) {
      try {
        const prontuario = await serviceRecords.recordById(id)
        commit('SetRecords', prontuario)
      } catch (error) {
        console.error(error)
        Swal.fire({
          icon: 'error',
          title: 'Erro ao buscar prontuário',
          text: 'Ocorreu um erro ao buscar o prontuário. Tente novamente mais tarde.',
        })
      }
    },
    async fetchMedicines({ commit, state }, query) {
      try {
        const params = {
          nome: query,
          pagina: 1,
        }
        const bulario = await serviceRecords.fetchMedicines(params)
        commit('SetMedicaments', bulario.content)
      } catch (error) {
        console.error(error)
        Swal.fire({
          icon: 'error',
          title: 'Erro ao buscar bulario',
          text: 'Ocorreu um erro ao buscar o bulario. Tente novamente mais tarde.',
        })
      }
    },
    async fetchPrescriptionModelo({ commit }) {
      try {
        const prescriptionModelo = await servicePRescription.getPrescriptions()
        commit('SetPrescriptionModelo', prescriptionModelo.data)
      } catch (error) {
        console.error(error)
      }
    },

    async createPrescription({ state }) {
      try {
        const data = {
          title: `${state.records.prescription.medicamentsSelected.nomeProduto} - ${state.records.prescription.selectVia.titulo} - ${state.records.prescription.selectCondicao.titulo}`,
          bulario_id: state.records.prescription.medicamentsSelected.idProduto,
          prescription: state.records.prescription.uso,
          condition_use: state.records.prescription.selectCondicao.titulo,
          via: state.records.prescription.selectVia.titulo,
          qtd: state.records.prescription.qtd,
        }
        await servicePRescription.createPrescription(data)
      } catch (error) {
        console.error(error)
      }
    },

    async deletePrescription({ state }) {
      try {
        await servicePRescription.deletePrescription(state.records.prescription.prescriptionModeloSelected.id)
      } catch (error) {
        console.error(error)
      }
    },

    async updatePrescription({ state }, data) {
      try {
        await servicePRescription.updatePrescription(data.id, data)
      } catch (error) {
        console.error(error)
      }
    },
  },
}
